/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { WorkforceProjectResource } from './';
import {
    WorkforceProjectResourceFromJSON,
    WorkforceProjectResourceFromJSONTyped,
    WorkforceProjectResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkforceProjectsListResource
 */
export interface WorkforceProjectsListResource {
    /**
     * 
     * @type {Array<WorkforceProjectResource>}
     * @memberof WorkforceProjectsListResource
     */
    items: Array<WorkforceProjectResource>;
    /**
     * Freelancer headline / job title shown in the panel
     * @type {string}
     * @memberof WorkforceProjectsListResource
     */
    freelancerHeadline?: string;
    /**
     * True when there are more projects to load beyond this page
     * @type {boolean}
     * @memberof WorkforceProjectsListResource
     */
    hasNext: boolean;
}

/**
 * Check if a given object implements the WorkforceProjectsListResource interface.
 */
export function instanceOfWorkforceProjectsListResource(value: object): value is WorkforceProjectsListResource {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('hasNext' in value) || value['hasNext'] === undefined) return false;
    return true;
}

export function WorkforceProjectsListResourceFromJSON(json: any): WorkforceProjectsListResource {
    return WorkforceProjectsListResourceFromJSONTyped(json, false);
}

export function WorkforceProjectsListResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkforceProjectsListResource {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(WorkforceProjectResourceFromJSON)),
        'freelancerHeadline': json['freelancerHeadline'] == null ? undefined : json['freelancerHeadline'],
        'hasNext': json['hasNext'],
    };
}

export function WorkforceProjectsListResourceToJSON(value?: WorkforceProjectsListResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map((v) => WorkforceProjectResourceToJSON(v))),
        'freelancerHeadline': value['freelancerHeadline'],
        'hasNext': value['hasNext'],
    };
}

